/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const userQueueV1ItemSchema = z.object({
  challengeId: z.number().int(),
  title: z.string(),
  type: z.string(),
  cefrLevel: z.string(),
  position: z.number().int(),
  queueSource: z.enum(['onboarding', 'random']),
  hasVideo: z.boolean(),
});

export type IUserQueueV1Item = z.infer<typeof userQueueV1ItemSchema>;

export const getUserQueueV1ResponseDataSchema = z.array(userQueueV1ItemSchema);

export type IGetUserQueueV1ResponseData = z.infer<typeof getUserQueueV1ResponseDataSchema>;

export const getUserQueueV1ResponseSchema = createApiResponseSchema(
  getUserQueueV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetUserQueueV1ResponseData>>;

export type IGetUserQueueV1Response = IAPI<IGetUserQueueV1ResponseData>;
